import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { IWordsPhrasesModel } from "components/Conversations/Views/Drawer/components/DeepFilter/WordsPhrasesStore";
import { buildHoverList, useChipFiltersStore } from "../BaseChipComponents/chipUtils";

const formatItem = (item: IWordsPhrasesModel): string => {
    const phrase = item.searchPhrase;
    if (item.value === "Does not contain") {
        return `NOT "${phrase}"`;
    }
    if (item.value === "Starts with") {
        return `STARTS WITH "${phrase}"`;
    }
    // Contains
    if (item.saidWithin != null) {
        return `"${phrase}" WITHIN ${item.saidWithin}`;
    }
    return `"${phrase}"`;
};

export const WordsAndPhrasesChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const handleRemove = () => {
        applicationFiltersStore.resetByKey("wordsAndPhrasesSearchString");
    };

    const isStandard = applicationFiltersStore.wordsAndPhrasesIsInputStandard;

    if (!isStandard) {
        const searchString = applicationFiltersStore.wordsAndPhrasesSearchString;
        if (!searchString?.trim()) return null;

        return (
            <AppliedFilterChip
                disabled={props.disabled}
                isApplicable={props.isApplicable}
                onRemove={handleRemove}
            >
                Words or Phrases: {searchString}
            </AppliedFilterChip>
        );
    }

    const nonEmptyItems = applicationFiltersStore.wordsAndPhrasesItems.filter(
        (item) => item.searchPhrase.trim() !== "",
    );

    if (nonEmptyItems.length === 0) return null;

    if (nonEmptyItems.length === 1) {
        return (
            <AppliedFilterChip
                disabled={props.disabled}
                isApplicable={props.isApplicable}
                onRemove={handleRemove}
            >
                Words or Phrases: {formatItem(nonEmptyItems[0])}
            </AppliedFilterChip>
        );
    }

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={handleRemove}
            tooltipContent={buildHoverList(nonEmptyItems.map(formatItem))}
        >
            {nonEmptyItems.length} Words or Phrases
        </AppliedFilterChip>
    );
});
